module.exports = __webpack_public_path__ + "static/media/wechat.6bfd05ee.svg";